<template>
  <div class="loader">
    <!-- <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#41b883"
    >
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1 1)" stroke-width="2">
          <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg> -->
    <!-- <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      class="lds-dual-ring"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke-linecap="round"
        r="40"
        stroke-width="4"
        stroke="#41b883"
        stroke-dasharray="62.83185307179586 62.83185307179586"
        transform="rotate(119.894 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1.6s"
          begin="0s"
          repeatCount="indefinite"
        ></animateTransform>
      </circle>
    </svg> -->
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#41b883"
    >
      <g fill="none" fill-rule="evenodd" stroke-width="2">
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="0s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="0s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="-0.9s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="-0.9s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  // props: {
  //   type: {
  //     type: String,
  //     default: 'text',
  //   },
  //   value: {
  //     type: [String, Number],
  //     default: '',
  //   },
  // },
}
</script>

<style lang="scss">
.loader {
  opacity: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  transition: opacity 0.5s;
  position: absolute;
  text-align: center;
  background-color: #212120;
  svg {
    width: 5%;
  }
}
.loading {
  .loader {
    display: block;
    z-index: 1000;
    opacity: 1;
  }
}
</style>
